import { translate } from '../i18n/translate';

/**
 * Legacy message lookup, kept because ~80 call sites already use it.
 *
 * The texts themselves moved into the i18n catalogs under `label.<id>`, so
 * every existing `getLabel('foo')` call now follows the language the person
 * picked without any of those call sites changing. New strings should use
 * `useT()` / `translate()` directly instead of adding label ids here.
 */
export const getLabel = (id: string): string =>
  translate(`label.${id}`, undefined, 'Missing Label');
